export default "__VITE_ASSET__CWuOYxQo__"